import React from 'react';
import styled from 'styled-components';
import ProgressBar from '../../../../dashboards/components/RiskProgressBar';

const Style = styled.div`
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  gap: var(--size-lg);
  margin-bottom: 12px;

  .progress-cont {
    display: flex;
    gap: 20px;

    .span {
      color: #001529;
      font-size: 12px;
      font-weight: 500;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-top: -3px;
    }
  }
`;

 const Assessment = ({
  t = (s) => s,
  data = 0,
}) => {
  return (
    <>
      <h3>{t('Assessment of Participant')}</h3>
      <Style>
        <div className="progress-cont">
          <div className="span">{t('Low')}</div>
          <div className="flex-col jus-c flex-1">
            <ProgressBar percentage={data} withTooltip />
          </div>
          <div className="span">{t('High')}</div>
        </div>
      </Style>
    </>
  )
};

export default Assessment;
